import React from 'react';
import { IoIosArrowForward } from 'react-icons/io';
import { BiInfoCircle } from 'react-icons/bi';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { AVATAR_IMAGE_URL, LEADERBOARD } from '../helpers/Constant';


const MonthlyLeaderBoard = ({ monthlyLeaderboardData = [],  userData, handleGoBurn, daysUntilMonthEnd,  monthlyUserPosition, onInfoClick,}) => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    function getPositionSuffix(position) {
        const suffixes = ['st', 'nd', 'rd'];
        const remainder = position % 10;

        if (position === 11 || position === 12 || position === 13) {
            return `${position}th`;
        }

        return `${position}${suffixes[remainder - 1] || 'th'}`;
    }

    const currentUserId = userData?._id?.toString();   
    
    return (
        <div className='reward_info_wrapper mt-3'>
            <div className='reward_chart rounded-corners p-3 bronze-chart monthly-leaderboard-container d-flex flex-column overflow-hidden'>
                <div className='row'>
                    <div className='col-12 px-3 d-flex justify-content-between align-items-start gap-2'>
                        <div>
                            <h4 className='text-white mb-1 opacity-75'><span className='me-1'>{t('Ends in')}</span>{daysUntilMonthEnd} {daysUntilMonthEnd === 1 ? t('day') : t('days')}</h4>
                            <p className='mb-2 text-white opacity-50 lh-1'>{t('You are currently at')}{" " + getPositionSuffix(monthlyUserPosition) + " "}{t('place')}</p>
                        </div>
                        {onInfoClick ? (
                            <BiInfoCircle className='text-light flex-shrink-0' role='button' onClick={onInfoClick} />
                        ) : null}
                    </div>
                </div>
                <ul className='reward_list pt-2 px-1 m-0 monthly-leaderboard-list'>
                    {monthlyLeaderboardData && monthlyLeaderboardData.length > 0 ? (
                        monthlyLeaderboardData.map((item, index) => {
                            const userName = item.fname || item.lname ? `${item.fname+' '}${item.lname}`.trim() : 'User';
                            const itemUserId = (item.user?._id || item.user)?.toString();
                            const isCurrentUser = itemUserId === userData?._id?.toString();

                            const actualRank = monthlyLeaderboardData.findIndex((leaderboardUser) => {
                                const id = (leaderboardUser.user?._id || leaderboardUser.user)?.toString();
                                return id === itemUserId;
                            }) + 1;
                            
                            return (
                                <li key={index} className={`d-flex align-items-center justify-content-between py-1 px-2 ${isCurrentUser ? 'active' : ''}`}>
                                    <div className='content_part d-flex align-items-center w-100 flex-nowrap'>
                                        <div className='d-block reward_item_wrapper count rounded-circle'>
                                            <span className='rounded-circle text-white'>{actualRank > 0 ? actualRank : index + 1}</span>
                                        </div>
                                        <div className='d-block reward_profile_wrapper'>
                                            {item.avtar ? (
                                                <img src={AVATAR_IMAGE_URL + itemUserId + "/" + item.avtar} alt='Leaderboard user' className='rounded-circle profile_img' />
                                            ) : (
                                                <div className='rounded-circle profile_img text-center d-flex align-items-center justify-content-center avtar_alternate border border-white'>
                                                    {userName.split(' ').map((word, idx) => (
                                                        <h6 key={idx} className='mb-0 text-white fw-bold text-uppercase'>
                                                            {word[0]}
                                                        </h6>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                        <div className='user_info flex-fill'>
                                            <h5 className='fw-bold mb-0 text-white'>{userName}</h5>
                                            <p className={`mb-0 opacity-75 ${item.status === 'Online' ? 'yellow' : 'text-light'}`}>{t(item.status || 'Away')}</p>
                                        </div>
                                        <div className='d-block reward_price_wrapper'>
                                            <div className='reward_price d-flex align-items-center ms-auto p-1 gap-1'>
                                                <span className='fw-bold d-flex align-items-center justify-content-center rounded-circle point_icon'></span>
                                                <h4 className='my-0 fw-bold text-white m-auto'>{item.point || 0}</h4>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            );
                        })
                    ) : (
                        <li className='d-flex align-items-center justify-content-center py-3'>
                            <p className='mb-0 text-white opacity-50'>{t('No leaderboard data available')}</p>
                        </li>
                    )}
                </ul>
                <button type='button' className='mx-auto cta_button text-dark d-flex align-items-center justify-content-center position-relative bg-warning mt-3' onClick={() => navigate(`/${LEADERBOARD}`)}>
                    <span className='fw-bold'>{t('View All')}</span>
                    <IoIosArrowForward className='next-icon' />
                </button>
            </div>
            <div className='premium_button_wrapper position-fixed start-0 end-0 p-3 text-center'>
                <button className='cta_button bg-warning' type='button' onClick={handleGoBurn}>
                    {t('Go to Burn')} <IoIosArrowForward />
                </button>
            </div>
        </div>
    );
};

export default MonthlyLeaderBoard;
